import { Component, Inject, PLATFORM_ID, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, Platform } from 'ionic-angular';
import { OperationService } from '../../../services/operations/operation/operation.service';
import { NavHelperService } from '../../../services/nav/nav-helper.service';
import { VesselService } from '../../../services/vessel/vessel.service';
import { AuthService } from '../../../_foundation/services/auth/auth.service';
import { isPlatformBrowser } from '@angular/common';
import { ResetPasswordEditor } from '../../../models/user-models';
import { UserService } from '../../../services/user/user.service';
import { AppConfig } from '../../../app/app.config';
import { PtLuxonDate } from '../../../models/projects/date.models';

@IonicPage()
@Component({
  selector: 'page-reset-passcode',
  templateUrl: 'reset-passcode.html',
})
export class ResetPasscodePage {
  @ViewChild('newPass') newPass;
  @ViewChild('newPassConfirm') newPassConfirm;

  config = AppConfig.settings;

  model: ResetPasswordEditor = new ResetPasswordEditor();
  failed = false;
  failedMessage: string = 'Login failed.';
  loggedIn = false;

  loading: boolean;
  currentTimeChanged: PtLuxonDate;
  isWeb: boolean;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    public navCtrl: NavController,
    public navParams: NavParams,
    public vesselService: VesselService,
    public operationService: OperationService,
    public platform: Platform,
    public navHelperService: NavHelperService,
    private authService: AuthService,
    private userService: UserService,
  ) {
  }

  ionViewWillLoad() {
    this.loading = true;
  }

  ionViewDidLoad() {
    this.isWeb = this.platform.is('core');
    this.currentTimeChanged = new PtLuxonDate();

    if (isPlatformBrowser(this.platformId)) {
      this.model.id = this.navParams.get('user').id;
    }
  }

  getEditor(metadata: any) {

  }

  focusNewPassInput() {
    this.newPass.setFocus();
  }

  focusNewPassConfirmInput() {
    this.newPassConfirm.setFocus();
  }

  reset() {
    this.failed = false;

    this.userService
      .resetPassword(this.model)
      .subscribe(res => {
        if (res === false) {
          return this.failed = true;
        }

        if (res === true) {
          this.navCtrl.pop();
        }
      }, err => {
        this.failed = true;
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/auth/reset-passcode/reset-passcode.ts